import { createAsyncThunk } from "@reduxjs/toolkit";
import { AIServiceSettingsService } from "./aiServiceSettingsService";

export class AIServiceSettingsActions {

    // Get AI Service Settings
    static getAIServiceSettings = createAsyncThunk(
        "AIServiceSettingsSlice/getAIServiceSettings",
        (data: { search?: string; provider?: string; offset?: number; limit?: number }, { dispatch, rejectWithValue }) => {
            return AIServiceSettingsService.getAIServiceSettings(data)
                .then(async (response: any) => {
                    return response
                })
                .catch((error: { response: unknown }) => {
                    return rejectWithValue(error?.response)
                })
                .finally(() => { })
        }
    )

    // Get AI Models
    static getAIModels = createAsyncThunk(
        "AIServiceSettingsSlice/getAIModels",
        (data: any, { dispatch, rejectWithValue }) => {
            return AIServiceSettingsService.getAIModels()
                .then(async (response: any) => {
                    return response
                })
                .catch((error: { response: unknown }) => {
                    return rejectWithValue(error?.response)
                })
                .finally(() => { })
        }
    )

    // Save AI Service Settings
    static saveAIServiceSettings = createAsyncThunk(
        "AIServiceSettingsSlice/saveAIServiceSettings",
        (data: any, { dispatch, rejectWithValue }) => {
            return AIServiceSettingsService.saveAIServiceSettings(data)
                .then(async (response: any) => {
                    return response
                })
                .catch((error: { response: unknown }) => {
                    return rejectWithValue(error?.response)
                })
                .finally(() => { })
        }
    )


    // Get API Key
    static getApiKey = createAsyncThunk(
        "AIServiceSettingsSlice/getApiKey",
        (data: any, { dispatch, rejectWithValue }) => {
            return AIServiceSettingsService.getApiKey()
                .then(async (response: any) => {
                    return response
                })
                .catch((error: { response: unknown }) => {
                    return rejectWithValue(error?.response)
                })
                .finally(() => { })
        }
    )
    // Get AI Providers
    static getAIProviders = createAsyncThunk(
        "AIServiceSettingsSlice/getAIProviders",
        (data: any, { dispatch, rejectWithValue }) => {
            return AIServiceSettingsService.getAIProviders()
                .then(async (response: any) => {
                    return response
                })
                .catch((error: { response: unknown }) => {
                    return rejectWithValue(error?.response)
                })
                .finally(() => { })
        }
    )
    // Save API Key
    static saveApiKey = createAsyncThunk(
        "AIServiceSettingsSlice/saveApiKey",
        (data: any, { dispatch, rejectWithValue }) => {
            return AIServiceSettingsService.saveApiKey(data)                         
                .then(async (response: any) => {
                    return response
                })
                .catch((error: { response: unknown }) => {
                    return rejectWithValue(error?.response)
                })
                .finally(() => { })
        }
    )
    // Save OpenRouter Settings        
    static saveOpenRouterSettings = createAsyncThunk(
        "AIServiceSettingsSlice/saveOpenRouterSettings",
        (data: any, { dispatch, rejectWithValue }) => {
            return AIServiceSettingsService.saveOpenRouterSettings(data)                         
                .then(async (response: any) => {
                    return response
                })
                .catch((error: { response: unknown }) => {
                    return rejectWithValue(error?.response)
                })
                .finally(() => { })
        }
    )
    // Get OpenRouter Settings        
    static getOpenRouterSettings = createAsyncThunk(
        "AIServiceSettingsSlice/getOpenRouterSettings",
        (data: any, { dispatch, rejectWithValue }) => {
            return AIServiceSettingsService.getOpenRouterSettings()                         
                .then(async (response: any) => {
                    return response
                })
                .catch((error: { response: unknown }) => {
                    return rejectWithValue(error?.response)
                })
                .finally(() => { })
        }
    )
    static passOpenRouterSettings = createAsyncThunk(           
        "AIServiceSettingsSlice/passOpenRouterSettings",
        (data: any, { dispatch, rejectWithValue }) => {
            return AIServiceSettingsService.passOpenRouterSettings(data)                         
                .then(async (response: any) => {
                    return response
                })
                .catch((error: { response: unknown }) => {
                    return rejectWithValue(error?.response)
                })
                .finally(() => { })
        }
    )   
    static deleteApiKey = createAsyncThunk(
        "AIServiceSettingsSlice/deleteApiKey",
        (data: any, { dispatch, rejectWithValue }) => {
            return AIServiceSettingsService.deleteApiKey(data)                         
                .then(async (response: any) => {
                    return response
                })
                .catch((error: { response: unknown }) => {
                    return rejectWithValue(error?.response)
                })
                .finally(() => { })
        }
    )
        
}